// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__yil23","label":"Category_label__2PpBb","content":"Category_content__2lRld","header":"Category_header__1Phwt","location":"Category_location__im_51"};